import React from "react";

const LoginFooter = () => {
  return (
    <>
      <div className="w-full flex justify-center py-2 border-t-2 select-none">
        <p className="text-gray-500"> Copyright  ©  2023   •   Sumersoft Tecnologia Ltda </p>
      </div>
    </>
  );
};

export default LoginFooter;
